import React, { useEffect, useState } from 'react'
import './candidatesubscription.css';
import { FaCheck } from "react-icons/fa";
import axios from 'axios';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { VendorProfile } from '../../../Redux/action/VendorProfileAction';
import { Button, Modal } from 'react-bootstrap';
import { CandidateProfile } from '../../../Redux/action/CandidateProfileAction';

const CandidateSubscription = () => {
    const { userResult } = useSelector((state) => state.Auth);
    const [activeTab, setActiveTab] = useState('MONTHLY');
    const [details, setDetails] = useState([]);
    const [needRender, setNeedRender] = useState(false);
    const [cancelModal, setCancelModal] = useState(false);
    const [isCurrentSubscription, setIsCurrentSubscription] = useState(false);
    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state?.Profile?.result);
    const plans = {
        Monthly: { free: 0, premium: 700, enterprise: 1200, type: "month" },
        Quarterly: { free: 0, premium: 2000, enterprise: 3500, type: "3month" },
        'Half Yearly': { free: 0, premium: 4000, enterprise: 6500, type: "6month" },
        Yearly: { free: 0, premium: 7500, enterprise: 12000, type: "1year" },
    };
    const PLAN_KEYS = {
        Monthly: "MONTHLY",
        Quarterly: "QUARTERLY",
        "Half Yearly": "HALF_YEARLY",
        Yearly: "YEARLY",
    };
    const order = ["FREE", "BASIC", "PREMIUM", "ENTERPRISE"];

    useEffect(() => {
        const id = userResult?.userid;
        dispatch(CandidateProfile(id));
    }, [needRender])

    async function getSubsriptionDetails() {
        const res = await axios.get(`${process.env.REACT_APP_API_PATH}/subscription_plan/get_subscription_plan_by_user_type?userType=CANDIDATE&duration=${activeTab}`);
        const data = await res.data;
        if (data?.data) {
            setDetails(data?.data)
        }
    }
    useEffect(() => {
        if (!userInfo?.userSubscription?.subscriptionPlan || !activeTab) return;

        const { duration, subscriptionId } = userInfo.userSubscription.subscriptionPlan;

        if (activeTab === duration) {
            const match = details.some(item => item.subscriptionId === subscriptionId);
            setIsCurrentSubscription(match);
        } else {
            setIsCurrentSubscription(false);
        }
    }, [activeTab, userInfo, details]);

    const sortedData = details.sort((a, b) =>
        order.indexOf(a.subscriptionType) - order.indexOf(b.subscriptionType)
    );
    useEffect(() => {
        getSubsriptionDetails();
    }, [activeTab]);

    const handleSubscriptionPlan = async (id) => {
        try {
            const orderResponse = await axios.post(`${process.env.REACT_APP_API_PATH}/payment/create_order`, {
                subscriptionPlanId: id,
                userId: userInfo.candidateId,
                userType: "CANDIDATE",
            });
            if (orderResponse?.status !== 201 || !orderResponse?.data?.status?.success) {
                throw new Error("Failed to create order");
            }
            const orderId = orderResponse.data.data.razorpayOrderId;
            const amount = orderResponse.data.data.amount
            // Step 2: Initialize Razorpay Payment
            const options = {
                key: "rzp_test_6RDAELPDeFpXXx",
                amount: parseInt(amount) * 100, // Convert to paisa
                currency: "INR",
                image: "https://shilsha-bckt.s3.ap-south-1.amazonaws.com/ebenchlogo.png",
                order_id: orderId, // Use the order ID from API response
                name: "Ebench",
                description: "For testing purpose",
                prefill: {
                    name: `${userInfo.firstName} ${userInfo.lastName}`,
                    email: userInfo.email,
                    contact: `${userInfo.countryCode}${userInfo.mobile}`
                },
                handler: async function (response) {
                    const paymentData = {
                        paymentId: response.razorpay_payment_id,
                        razorpayOrderId: response.razorpay_order_id,
                        razorpaySignature: response.razorpay_signature,
                    };
                    try {
                        const verifyResponse = await axios.put(`${process.env.REACT_APP_API_PATH}/payment/verify_payment`, paymentData);
                        if (verifyResponse?.status === 200 && verifyResponse?.data?.status?.success) {
                            dispatch(VendorProfile());
                            toast.success("Payment Verified Successfully!");
                            setNeedRender(true);
                        } else {
                            toast.error("Payment Verification Failed!");
                        }
                    } catch (error) {
                        console.error("Error verifying payment:", error);
                        toast.error("Error verifying payment. Please contact support.");
                    }
                },
                theme: {
                    color: "#2e3192",
                },
            };
            const Razorpay = window.Razorpay;
            if (Razorpay) {
                const pay = new Razorpay(options);
                pay.open();
            } else {
                console.error("Razorpay SDK is not loaded");
                toast.error("Razorpay SDK is not loaded");
            }
        } catch (error) {
            console.error("Error creating order:", error);
            toast.error("Please try again.");
        }
    };

    const handleCancelSubscription = async () => {
        try {
            const userId = userInfo?.candidateId; // Assuming user ID is stored in userInfo

            if (!userId) {
                console.error("User ID is missing!");
                return;
            }
            const response = await axios.patch(
                `${process.env.REACT_APP_API_PATH}/user_subscription/cancel_subscription?userId=${userId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.status === 200 && response.data.status.success) {
                console.log("Subscription canceled successfully!", response.data);
                toast.success("Subscription canceled successfully!");
                setNeedRender(true);
                setCancelModal(false)
            } else {
                console.error("Failed to cancel subscription", response.data);
                toast.error("Failed to cancel subscription. Please try again.");
            }
        } catch (error) {
            console.error("Error canceling subscription:", error);
            toast.error("Error canceling subscription. Please contact support.");
        }
    };

    const handleClose = () => {
        setCancelModal(false)
    }

    const subscriptionHierarchy = ["FREE", "BASIC", "PREMIUM", "ENTERPRISE"];
    const userSubscriptionIndex = subscriptionHierarchy.indexOf(userInfo?.userSubscription?.subscriptionPlan?.subscriptionType);
    return (
        <div className="pricing-container-custom">
            <ToastContainer />
            <h1 className="pricing-title-custom">Unlock Your Career Potential with Ebench</h1>
            <p className="pricing-subtitle-custom">Subscribe today to access exclusive job opportunities, personalized career tools, and expert insights!</p>
            {userInfo?.userSubscription?.subscriptionPlan?.status === false && <div className='seleted-subscription-container highlight-free'>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                        <div style={{ display: 'flex', gap: '1rem' }}>
                            <h2 style={{ color: '#37517E', fontSize: '1.8rem', paddingTop: '5px' }}>{userInfo?.userSubscription?.subscriptionPlan?.subscriptionType}</h2>
                            <p className="price-custom">
                                &#8377;{parseInt(userInfo?.userSubscription?.subscriptionPlan?.discountedPrice)} <span className="text-cut">{userInfo?.userSubscription?.subscriptionPlan?.discountPercentage ? userInfo?.userSubscription?.subscriptionPlan?.price : ""}</span>
                                {userInfo?.userSubscription?.subscriptionPlan?.price > 0 && <span className="month-span">/{userInfo?.userSubscription?.subscriptionPlan?.duration == "HALF_YEARLY" ? "half yearly" : userInfo?.userSubscription?.subscriptionPlan?.duration}</span>}
                            </p>
                        </div>
                        {
                            <div>
                                <IoMdCheckmarkCircleOutline color='green' size={30} />
                            </div>
                        }
                    </div>
                    <hr />
                    <div className="seleted-feature-list">
                        {userInfo?.userSubscription?.subscriptionPlan?.featureList?.map((feature, index) => (
                            <div key={index} className="seleted-feature-item">
                                <FaCheck color="green" /> {feature}
                            </div>
                        ))}
                    </div>
                    {((userInfo.userSubscription.autoRenew && userInfo?.userSubscription?.subscriptionPlan?.subscriptionType !== "FREE")) && (
                        <div style={{ width: '100%', justifyContent: 'end', display: 'flex' }}>
                            <button onClick={() => { setCancelModal(true) }} className="cancel-button-custom-v2">Cancel Subscription</button>
                        </div>
                    )}
                    <hr />
                    <div style={{ color: '#ffc107', textAlign: 'start' }}>You are subscribed to the old {userInfo?.userSubscription?.subscriptionPlan?.subscriptionType} plan, which will no longer be available after expiry. A new {userInfo?.userSubscription?.subscriptionPlan?.subscriptionType} plan is now available with updated features.</div>
                </div>
            </div>}
            <div className="toggle-buttons-custom">
                {Object.keys(plans).map((tab) => (
                    <button
                        key={tab}
                        className={activeTab === PLAN_KEYS[tab] ? 'active-custom' : ''}
                        onClick={() => { setActiveTab(PLAN_KEYS[tab]) }} // Set the uppercase value
                    >
                        {tab}
                    </button>
                ))}
            </div>
            <div className="plans-container-custom">
                {
                    sortedData?.length > 0 ? sortedData?.map((item) => {
                        const isFree = item?.subscriptionId === userInfo?.userSubscription?.subscriptionPlan?.subscriptionId && userInfo?.userSubscription?.subscriptionPlan?.status;
                        return (
                            <>
                                <div className={`plan-card-custom ${isFree ? 'highlight-free' : ''}`}>
                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', }}>
                                            <h2 style={{ color: '#37517E', fontSize: '1.8rem' }}>{item?.subscriptionType}</h2>
                                            {
                                                isFree &&
                                                <div>
                                                    <IoMdCheckmarkCircleOutline color='green' size={30} />
                                                </div>
                                            }
                                        </div>
                                        <hr style={{ margin: "0px" }} />
                                        <p className="price-custom">
                                            &#8377; {parseInt(item?.discountedPrice)} <span className="text-cut">{item.discountPercentage ? item?.price : ""}</span>
                                            {item?.price > 0 && <span className="month-span">/{item?.duration == "HALF_YEARLY" ? "half yearly" : item?.duration}</span>}
                                        </p>
                                        <div className="features-custom">
                                            {item?.featureList?.map((feature, index) => (
                                                <ul key={index}>
                                                    <li>
                                                        <FaCheck color="green" /> {feature}
                                                    </li>
                                                </ul>
                                            ))}
                                        </div>
                                    </div>
                                    {(!isFree && item.price !== 0 && userSubscriptionIndex <= subscriptionHierarchy.indexOf(item.subscriptionType)) && (
                                        <div style={{ justifyContent: 'end' }}>
                                            <button
                                                disabled={true}
                                                onClick={() => handleSubscriptionPlan(item.subscriptionId)}
                                                className="select-button-custom"
                                            >
                                                Upgrade
                                            </button>
                                        </div>
                                    )}
                                    {(isFree && (userInfo.userSubscription.autoRenew && userInfo?.userSubscription?.subscriptionPlan?.subscriptionType !== "FREE")) && (
                                        <div style={{ justifyContent: 'end' }}>
                                            <button  disabled={true} onClick={() => { setCancelModal(true) }} className="cancel-button-custom">Cancel Subscription</button>
                                        </div>
                                    )}
                                </div>
                            </>
                        );
                    }) : (
                        <div>No Subscription Found</div>
                    )
                }
            </div>
            <Modal
                show={cancelModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                style={{ top: "30%" }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Cancel Subscription</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to cancel this subscription?
                </Modal.Body>
                <Modal.Footer className='flex-center' style={{ justifyContent: "center" }}>
                    <Button className="btn-primary-custom" onClick={() => handleCancelSubscription()}>Submit</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default CandidateSubscription
